// extracted by mini-css-extract-plugin
export var brand = "_42-9";
export var compact = "_42-6";
export var extraSmall = "_42-7";
export var icon = "_42-0";
export var large = "_42-4";
export var light = "_42-1";
export var medium = "_42-5";
export var outline = "_42-b";
export var primaryDark = "_42-a";
export var primaryLight = "_42-8";
export var primaryModern = "_42-c";
export var success = "_42-2";
export var successSolid = "_42-3";